export default __webpack_public_path__ + "static/media/services_enviro_1.6396c1a2.jpg";